export default function EventConfigContainer() {}
